import { getPlatformFromUserAgent } from './getPlatformFromUserAgent';
import { useApplicationContext } from '../applicationContext';

export const usePlatform = () => {
  const {
    custom: { userAgent },
  } = useApplicationContext();

  return getPlatformFromUserAgent(userAgent);
};
